import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import DashboardIcon from '@/shared/assets/icons/dashboard/dashboard.svg?react'
import DealsIcon from '@/shared/assets/icons/dashboard/deals.svg?react'
import DetailsIcon from '@/shared/assets/icons/dashboard/details.svg?react'
import DevicesIcon from '@/shared/assets/icons/dashboard/devices.svg?react'
import FinanceIcon from '@/shared/assets/icons/dashboard/finance.svg?react'
import OrdersIcon from '@/shared/assets/icons/dashboard/orders.svg?react'
import PayoutIcon from '@/shared/assets/icons/dashboard/payout.svg?react'
import ReferralIcon from '@/shared/assets/icons/dashboard/referral.svg?react'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'

type NavMenuProps = {
  setIsSidebarOpen: (value: boolean) => void
}

const icons: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  dashboard: DashboardIcon,
  deals: DealsIcon,
  payout: PayoutIcon,
  finance: FinanceIcon,
  orders: OrdersIcon,
  details: DetailsIcon,
  devices: DevicesIcon,
  referral: ReferralIcon,
}

const menuItems = [
  { name: 'Дашборд', icon: 'dashboard', link: '/dashboard' },
  { name: 'Входящие заявки', icon: 'deals', link: '/deals' },
  { name: 'Исходящие заявки', icon: 'payout', link: '/payout' },
  { name: 'Финансы', icon: 'finance', link: '/finance' },
  { name: 'Споры', icon: 'orders', link: '/orders' },
  { name: 'Реквизиты', icon: 'details', link: '/requisites' },
  { name: 'Устройства', icon: 'devices', link: '/devices' },
  { name: 'Реферальная система', icon: 'referral', link: '/referrals' },
]

export const NavMenu = ({ setIsSidebarOpen }: NavMenuProps) => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)

  const filteredMenuItems = menuItems.filter((item) => {
    if (userRole === Roles.Merchant) {
      return item.link !== '/panel/requisites' && item.link !== '/panel/devices'
    }
    return true
  })

  return (
    <nav className="flex flex-col h-full overflow-hidden">
      <ul className="flex-1 space-y-2 pb-2 min-h-[210px] md:min-h-[285px] overflow-y-auto custom-scrollbar">
        {filteredMenuItems.map((item) => {
          const IconComponent = icons[item.icon]
          return (
            <NavLink
              key={item.name}
              to={item.link}
              onClick={() => setIsSidebarOpen(false)}
              className={({ isActive }) =>
                clsx(
                  'group flex justify-between items-center px-4 py-2 rounded-lg font-klein font-medium transition-all cursor-pointer',
                  'text-text-secondary hover:bg-light-purple hover:dark:bg-card-border-dark',
                  isActive && 'bg-light-purple dark:bg-card-border-dark'
                )
              }
            >
              {({ isActive }) => (
                <div className="flex items-center space-x-3">
                  <IconComponent
                    className={clsx(
                      'w-6 h-6 group-hover:dark:text-primary-dark-hover group-hover:text-primary',
                      isActive && 'text-primary dark:text-primary-dark-hover'
                    )}
                  />
                  <span
                    className={clsx(
                      'group-hover:dark:text-white group-hover:text-primary',
                      isActive && 'text-primary dark:text-white'
                    )}
                  >
                    {item.name}
                  </span>
                </div>
              )}
            </NavLink>
          )
        })}
      </ul>
    </nav>
  )
}
